<form>
  <div class="row">
  <div class="col-md-12 col-xl-12">
    <div class="table-responsive our-table">
      <table class="table table-striped text-nowrap mb-0">
        <thead class="border-top">
          <tr>
            <th scope="col" class="text-capitalize">{{ 'common.date' | translate}}</th>
            <th scope="col" class="text-capitalize">{{ 'common.transactionId' | translate}}</th>
            <th scope="col" class="text-capitalize"> </th>
            <th scope="col" class="text-capitalize">{{ 'common.type' | translate}}</th>
            <th scope="col" class="text-capitalize">{{ 'common.status' | translate}}</th>
            <th scope="col" class="text-capitalize">{{ 'common.requestedValue' | translate}}</th>
            <th scope="col" class="text-capitalize">{{ 'common.fees' | translate}}</th>
            <th scope="col" class="text-capitalize"> {{ nameColumn }} </th>
            <th scope="col" class="text-capitalize">{{ 'common.amountMoved' | translate}}</th>
            <th scope="col" class="text-capitalize">{{ 'common.origin' | translate}}</th>
            <th scope="col" class="text-capitalize">{{ 'common.description' | translate}}</th>
            <th scope="col" class="text-capitalize">{{ 'common.idempotencyKey' | translate}}</th>
          </tr>
        </thead>
        <tbody>
        <tr class="border-bottom" *ngFor="let transaction of transactions">
            <td><span>{{transaction.data | date : 'dd/MM/yyyy HH:mm:ss':'GMT'}}</span></td>
            <td><span>{{transaction.codigo}}</span></td>
            <td><span *ngIf="transaction.tipo === 'Saque'
                             && (transaction.origem === 'PIX' && isValidPixDate(transaction.data) || transaction.origem === 'TEF' && 
                             isValidTefDate(transaction.data))"
                            ><i class="btn fe fe-file" (click)="downloadReceipt(transaction)"></i></span></td>
            <td><span class="text-{{transaction.textColor}}">{{transaction.tipo | label:'type'}}</span></td>
            <td><span>{{transaction.status}}</span></td>
            <td><span>{{ transaction.valorSolicitado | formatCurrency }}</span></td>
            <td><span>{{ ((!transaction.splitTaxa && !transaction.splitTaxaAdm) ? 
                      transaction.taxaAdministrativa : transaction.splitTaxaAdm) | formatCurrency}}</span></td>
            <td><span>{{transaction.splitTaxa | formatCurrency }}</span></td>
            <td><span>{{transaction.valorMovimentado | formatCurrency }}</span></td>
            <td><span>{{transaction.origem}}</span></td>
            <td><span>{{transaction.responsavel}}</span></td>
            <td><span>{{transaction.idempotencyKey}}</span></td>
          </tr>
          <tr *ngIf="transactions.length == 0">
            <td colspan="12">{{ 'common.noData' | translate}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="d-flex justify-content-between p-2">
      <ngb-pagination
        [collectionSize]="total" [maxSize]="5" [rotate]="true" [(page)]="page" [pageSize]="pageSize" (pageChange)="pageChange()">
      </ngb-pagination>
    </div>
    </div>
  </div>
</form>
